export const DASHBOARD_INDICATOR = "DASHBOARD_INDICATOR"